<div class="boma-footer grid mx-0 my-1" style="width: 100%">
  <div class="col-12 mx-0 pr-0">
    <hr />
  </div>

  <div class="col-6 mt-1">
    Powered by
    <img
      [src]="'assets/layout/images/brand/logo-h-dark-text.svg'"
      alt="Boma :: Trade Your Way"
      class="logo-image"
      style="max-height: 1.5em; display: inline-block; vertical-align: middle"
    />
    Trade Your Way
    <p>
      <small><a href="https://boma.today">https://boma.today</a></small>
    </p>
  </div>
  <div class="col-6 text-right mt-1">
    {{ this.footerText }}
  </div>
</div>
